<script>
  import {subNavigation} from "@util/constant"
</script>


<nav class="small-top-navigation">
  <ul>
    {#each subNavigation.filter(nav => !nav.footer) as navigation}
      <li
        class="small-top-navigation-list">
        <a
          href={navigation.href}
          target="{navigation.blank ? "_blank" : undefined}"
          aria-label="{navigation}へのナビゲーションです"
          id={navigation.sendSPID ? navigation.sendSPID : undefined}
          class="small-top-navigation-list-link">
          <div class="small-top-navigation-list-link-block">
            <span class="menu-label-icon"><img src={navigation.iconPath} alt="icon" width="24" height="24"></span>
            <span class="owd-text:01"><strong>{navigation.label}</strong></span>
          </div>
          <span class="small-top-navigation-list-link-icon"><img src="/assets_default/icons/chevron_right.svg" width="24" height="24" alt=""></span>
        </a>
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">


  .small-top-navigation {
    width: 100%;
    background: var(--primary-white);
    // padding-top: 24px;
    position: relative;
    z-index: 2;
    border-top: solid 1px var(--black-opacity1);
    &-list {
      background: var(--primary-white);
      width: 100%;
      border-bottom: 1px solid var(--border);

      &-link {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        display: grid;
        grid-template-columns: 1fr 24px;
        align-items: center;
        padding: 16px 24px;
        width: 100%;
        min-height: 76px;
        text-decoration: none;
        border-bottom: solid 1px var(--black-opacity1);
        &-block{
          display: grid;
          grid-template-columns: 24px 1fr;
          gap: 8px;
          align-items: center;
        }

        &-icon {
          height: 24px;
        }
      }
    }
  }

  .small-top-button {
    margin: 0 auto;
    text-align: center;
    padding: 40px 24px 24px;
  }

</style>
